import BaseAPI from "../api";

const path: string = "district-sub";

export class SubDistrictApi extends BaseAPI {
  static getAllSubDistrict(query?: any): Promise<any> {
    return this.api.get(`${path}`, {
      params: { ...query },
    });
  }

  static createSubDistrict(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }

  static getSubDistrictByDistrict(id: number, query?: any): Promise<any> {
    return this.api.get(`${path}/find-by-district/${id}`, {
      params: { ...query },
    });
  }

  static updateSubDistrict(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }

  static deleteSubDistrict(id: number): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }

  static getSubDistrictById(id: number): Promise<any> {
    return this.api.get(`${path}/${id}/get-by-id`);
  }
}